import { amountWithCurrencySymbol } from '@/helpers/currency';
import { getPoolStatus, type IPool, roundHitRange } from '@/helpers/jackpot';

import { useExchangeAmount } from './useExchangeAmount';

export const usePoolData = ({ prize, hitRange, minBet }: IPool) => {
  const {
    getExchangeAmount,
    formatNumber,
    formatExchangedAmount,
    formatMinBet,
    displayCurrency,
  } = useExchangeAmount();

  const range = roundHitRange(
    {
      from: getExchangeAmount(hitRange.from),
      to: getExchangeAmount(hitRange.to),
    },
    displayCurrency
  );

  return {
    formattedPrize: formatExchangedAmount(prize, 2),
    formattedHitRange: amountWithCurrencySymbol(
      displayCurrency,
      `${formatNumber(range.from)}-${formatNumber(range.to)}`,
      { noDecimals: true }
    ),
    formattedMinBet: formatMinBet(minBet),
    poolStatus: getPoolStatus(prize, hitRange),
  };
};
